import React, { useState, useEffect } from 'react'
import { Alert, Box, TextField, Button, TableContainer, Table, TableHead, TableCell, TableRow, Paper, TableBody, Select, MenuItem, CircularProgress } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { downloadDocument, getFeedstockTransport, postFeedstockTransport } from '../../../../../actions/tigercat-burns/tigercat-actions';
import { v4 as uuidv4 } from 'uuid';
import useTsPaginator from 'ts-paginator';
import Paginator from '../../../../layout/Pagination';
import { getTableTotalRecordCount } from '../../../../../actions/tigercat-burns/tigercat-base-actions';

const FeedstockTransport = ({ projectId, project }) => {
    const [feedstockTransportState, setFeedstockTransportState] = useState([])
    const dispatch = useDispatch()
    const feedstockTransports = useSelector(state => state.tigercatBurnsReducer.feedstockTransports.data)
    const [loading, setLoading] = useState(false)
    const tableRecordCount = useSelector(state => state.tigercatBurnsBaseReducer.totalRecordCount.count)
    const [error, setError] = useState(false)
    const {
        totalRecordCount,
        rowsPerPage,
        currentPage,
        _determinePaginationMessage,
        _determinePaginationDisabledState,
        // _determinePaginationPages,
        _determineRowsPerPageOptions,
        _handleChangeTotalRecordCount,
        _handleChangeRowsPerPage,
        _handleChangePage,
    } = useTsPaginator(+tableRecordCount || 0, 0);
    useEffect(() => {
        dispatch(getFeedstockTransport(projectId, rowsPerPage, currentPage));
        dispatch(getTableTotalRecordCount('feedstock_transport', projectId));
    }, [dispatch, projectId, rowsPerPage, currentPage]);

    useEffect(() => {
        // if (currentProjectId !== projectId) {
        _handleChangePage(0); // Reset to the first page
        _handleChangeRowsPerPage(10)
        _handleChangeTotalRecordCount(+tableRecordCount); // Reset to the first page
        // }
    }, [projectId, tableRecordCount]);

    useEffect(() => {
        const formDataArray = feedstockTransports?.map((item) => {
            const formData = new FormData();
            formData.append('id', item.id);
            formData.append('feedstockType', item.feedstockType);
            formData.append('feedstockMass', item.feedstockMass);
            formData.append('distanceTravelled', item.distanceTravelled);
            formData.append('numberOfTrips', item.numberOfTrips);
            formData.append('transportType', item.transportType);
            formData.append('deliveredBy', item.deliveredBy);
            formData.append('sourceDocument', item.sourceDocumentUrl);
            formData.append('comments', item.comments);
            formData.append('disabled', true)
            return formData;
        });
        setFeedstockTransportState(formDataArray);
    }, [feedstockTransports]);

    const handleAddItem = () => {
        setFeedstockTransportState((prevState) => {
            const state = [...prevState]
            const formData = new FormData();
            formData.append('id', null);
            formData.append('rowId', uuidv4())
            formData.append('feedstockType', '');
            formData.append('feedstockMass', '');
            formData.append('distanceTravelled', '');
            formData.append('numberOfTrips', '');
            formData.append('transportType', 'Medium- and Heavy-Duty Truck');
            formData.append('deliveredBy', '');
            formData.append('sourceDocument', null);
            formData.append('comments', '');
            state.push(formData)
            return state
        })
    }

    const handleInputChange = (e, dataId, field) => {
        setFeedstockTransportState((prevState) => {
            return prevState.map((item) => {
                if (item.get('rowId') === dataId) {
                    item.set(field, e.target.value);
                }
                return item;
            });
        });
    }

    const handleSourceDoc = (e, dataId) => {
        const file = e.target.files[0];
        setFeedstockTransportState((prevState) => {
            return prevState.map((item) => {
                if (item.get('rowId') === dataId) {
                    item.set('sourceDocument', file);
                }
                return item;
            });
        });
    }

    const transportTypes = [
        { id: 0, name: 'Medium- and Heavy-Duty Truck' }
    ]

    const handleSubmitData = () => {
        setLoading(true)
        let hasError = false
        feedstockTransportState.forEach((i) => {
            if (i.get('feedstockType') === '' || i.get('feedstockMass') === '' || i.get('distanceTravelled') === '' || i.get('numberOfTrips') === '' || i.get('deliveredBy') === '') {
                setError(true)
                hasError = true
                return
            }
        })
        if (!hasError) {
            dispatch(postFeedstockTransport(projectId, feedstockTransportState)).then(() => {
                dispatch(getFeedstockTransport(projectId, rowsPerPage, currentPage)).then(() => {
                    dispatch(getTableTotalRecordCount('feedstock_transport', projectId)).then(() => {
                        setLoading(false)
                    })
                })
            })
        } else {
            setLoading(false)
        }
    }

    const handleDownload = async () => {
        try {
            dispatch(downloadDocument(projectId, 'feedstock_transport')).then((response) => {

                // Create a downloadable link for the Excel file
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${project}_feedstock_transport.xlsx`); // Set the file name
                document.body.appendChild(link);
                link.click();
                link.remove();
            })

        } catch (err) {
            console.error('Error downloading Feedstock Transport:', err);
        }
    };

    return (
        <>
            <h2>Feedstock Transport</h2>
            <TableContainer key={0} component={Paper} >
                <Button variant='contained' sx={{ height: 'auto', float: 'right', mt: 2, mb: 2 }} onClick={handleDownload}>Download Excel</Button>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell size="small" align="left">Feedstock Type</TableCell>
                            <TableCell size="small" align="left">Mass of Feedstock Per Trip (tonne)</TableCell>
                            <TableCell size="small" align="left">One-way Distance Per Trip (km)</TableCell>
                            <TableCell size="small" align="left">Number of Trips</TableCell>
                            <TableCell size="small" align="left">Transport Type</TableCell>
                            <TableCell size="small" align="left">Delivered By</TableCell>
                            <TableCell size="small" align="left">Upload Source Document (optional)</TableCell>
                            <TableCell size="small" align="left">Comments (optional)</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {feedstockTransportState?.map((data, index) => {
                            const sourceDocument = data.get('sourceDocument');
                            const isString = typeof sourceDocument === 'string' && sourceDocument !== 'null';
                            return (
                                <TableRow key={index}>
                                    <TableCell size="small" align="left">
                                        <TextField
                                            name='feedstockType'
                                            value={data.get('feedstockType')}
                                            onChange={(e) => handleInputChange(e, data.get('rowId'), 'feedstockType')}
                                            type="text"
                                            disabled={data.get('disabled') ?? false}
                                        />
                                    </TableCell>
                                    <TableCell size="small" align="left">
                                        <TextField
                                            name='feedstockMass'
                                            value={data.get('feedstockMass')}
                                            onChange={(e) => handleInputChange(e, data.get('rowId'), 'feedstockMass')}
                                            type="number"
                                            disabled={data.get('disabled') ?? false}
                                        />
                                    </TableCell>
                                    <TableCell size="small" align="left">
                                        <TextField
                                            name='distanceTravelled'
                                            value={data.get('distanceTravelled')}
                                            onChange={(e) => handleInputChange(e, data.get('rowId'), 'distanceTravelled')}
                                            type="number"
                                            disabled={data.get('disabled') ?? false}
                                        />
                                    </TableCell>
                                    <TableCell size="small" align="left">
                                        <TextField
                                            name='numberOfTrips'
                                            value={data.get('numberOfTrips')}
                                            onChange={(e) => handleInputChange(e, data.get('rowId'), 'numberOfTrips')}
                                            type="number"
                                            disabled={data.get('disabled') ?? false}
                                        />
                                    </TableCell>
                                    <TableCell size="small" align="left">
                                        <Select name='transportType' value={data.get('transportType')} disabled={true} fullWidth onChange={(e) => handleInputChange(e, data.get('id'), 'transportType')}>
                                            {transportTypes?.map(type => {
                                                return (
                                                    <MenuItem key={type.id} value={type.name} >
                                                        {type.name}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </TableCell>
                                    <TableCell size="small" align="left">
                                        <TextField
                                            name='deliveredBy'
                                            value={data.get('deliveredBy')}
                                            onChange={(e) => handleInputChange(e, data.get('rowId'), 'deliveredBy')}
                                            type="text"
                                            disabled={data.get('disabled') ?? false}
                                        />
                                    </TableCell>
                                    <TableCell size="small" align="left">
                                        {isString ? (
                                            <a href={sourceDocument} target="_blank" rel="noopener noreferrer">
                                                Document
                                            </a>
                                        ) : (
                                            <TextField
                                                disabled={data.get('disabled')}
                                                name={'sourceDocument'}
                                                defaultValue={sourceDocument && sourceDocument.name ? sourceDocument.name : ''}
                                                onChange={(e) => handleSourceDoc(e, data.get('rowId'))}
                                                type="file"
                                            />
                                        )}
                                    </TableCell>
                                    <TableCell size="small" align="left">
                                        <TextField
                                            name='comments'
                                            value={data.get('comments')}
                                            onChange={(e) => handleInputChange(e, data.get('rowId'), 'comments')}
                                            type="text"
                                            disabled={data.get('disabled') ?? false}
                                        />
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <Paginator
                totalRecordCount={totalRecordCount}
                rowsPerPage={rowsPerPage}
                currentPage={currentPage}
                handleChangePage={_handleChangePage}
                handleChangeRowsPerPage={_handleChangeRowsPerPage}
                determinePaginationMessage={_determinePaginationMessage}
                determinePaginationDisabledState={_determinePaginationDisabledState}
                determineRowsPerPageOptions={_determineRowsPerPageOptions}
            />
            {error ? <Alert severity='error' sx={{ my: 2 }}>Please fill out all fields before submitting</Alert> : null}
            <Box sx={{ position: 'relative', mb: 10 }}>
                <Button variant='contained' sx={{ height: 'auto', mt: 2 }} onClick={handleAddItem}>Add Entry</Button>
                {loading ? <CircularProgress sx={{ position: 'absolute', left: '125px', top: '12px' }}></CircularProgress> : <Button variant='contained' sx={{ height: 'auto', mt: 2, ml: 3 }} onClick={handleSubmitData}>Submit Data</Button>}
                {loading && <Alert severity='info' sx={{ my: 2 }}>Please be patient during data submission as file uploads can take some time to complete</Alert>}
            </Box>
        </>
    )
}

export default FeedstockTransport